import { render, staticRenderFns } from "./HorizantalLayout.vue?vue&type=template&id=587ece5c&"
import script from "./HorizantalLayout.vue?vue&type=script&lang=js&"
export * from "./HorizantalLayout.vue?vue&type=script&lang=js&"
import style0 from "./HorizantalLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports